export default __webpack_public_path__ + "static/fractal_vertical-2d0613d4b59523d0ccfbe4175bbd4dae.svg";